import { RoleOptions } from '@contexts/users/domain';

import type { BreadcrumbConfig } from '@components/molecules/breadcrumbs/models/breadcrumb';
import type { DynamicOptionsParams } from '@components/molecules/breadcrumbs/services/breadcrumbs.service';

import { routesMetadata } from '@shared/models';
import type {
	AccessContext,
	AccessStrategy,
	AdminPermission,
	WidgetConfig
} from '@shared/services';

const SUPPORT_PERMISSIONS: ReadonlySet<AdminPermission> = new Set<AdminPermission>([
	'users.unlock',
	'users.supplant',
	'recordedDevices.supplant'
]);

export class SupportAccessStrategy implements AccessStrategy {
	getWidgets(): WidgetConfig[] {
		return [
			{
				id: 'companies',
				label: 'entities.companies.title',
				routerLink: routesMetadata.companies.relative,
				icon: 'company'
			},
			{
				id: 'delegations',
				label: 'entities.delegations.title',
				routerLink: routesMetadata.delegations.relative,
				icon: 'delegation'
			},
			{
				id: 'users',
				label: 'entities.users.title',
				routerLink: routesMetadata.users.relative,
				icon: 'users'
			},
			{
				id: 'recorded-devices',
				label: 'entities.recordedDevices.title',
				routerLink: routesMetadata.recordedDevices.relative,
				icon: 'device'
			},
			{
				id: 'audits',
				label: 'entities.audits.title',
				routerLink: routesMetadata.audits.relative,
				icon: 'audit'
			}
		];
	}

	private buildBaseBreadcrumbs(): BreadcrumbConfig {
		return {
			levels: [
				{
					id: 'section',
					controlsSegmentAt: 0,
					options: [
						{
							id: 'companies',
							label: 'entities.companies.title',
							segment: routesMetadata.companies.relative,
							navigable: true
						},
						{
							id: 'delegations',
							label: 'entities.delegations.title',
							segment: routesMetadata.delegations.relative,
							navigable: true
						},
						{
							id: 'users',
							label: 'entities.users.title',
							segment: routesMetadata.users.relative,
							navigable: true
						},
						{
							id: 'recorded-devices',
							label: 'entities.recordedDevices.title',
							segment: routesMetadata.recordedDevices.relative,
							navigable: true
						},
						{
							id: 'audits',
							label: 'entities.audits.title',
							segment: routesMetadata.audits.relative,
							navigable: true
						}
					]
				}
			]
		};
	}

	async getBreadcrumbs(_: AccessContext): Promise<[BreadcrumbConfig, DynamicOptionsParams[]]> {
		const baseConfig = this.buildBaseBreadcrumbs();

		return [baseConfig, []];
	}

	canAccess(roles: string[]): boolean {
		return roles.includes(RoleOptions.SUPPORT);
	}

	canWrite(): boolean {
		return false;
	}

	can(permission: AdminPermission): boolean {
		return SUPPORT_PERMISSIONS.has(permission);
	}
}
